export const getTotalMemory = () => {};
export const getUsedMemory = () => {};
export const getFreeDiskStorage = () => {};
export const getFirstInstallTime = () => {};
export const isLowRamDevice = () => {};
